import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import { HttpError } from 'core/components';

import PageGlobalError from 'hcp/components/page/global-error';

<template>
  <main id="content">
    {{#if
      (eq
        @controller.model.error
        "email address on invitation does not match user principal primary email address"
      )
    }}
      <PageGlobalError
        @variant="invite-email-mismatch"
        @error={{@controller.model}}
      />
    {{else}}
      <HttpError
        class="hcp-min-height-100-vh"
        @code={{@controller.model.status}}
        as |Error|
      >
        <Error.LinkStandalone
          @icon="chevron-left"
          @iconPosition="leading"
          @route="cloud"
          @text={{t "helpers.options-for-http-error.go-back"}}
        />
      </HttpError>
    {{/if}}
  </main>
</template>
